import { cn } from "@/lib/utils";

/**
 * Marketing section wrapper that owns the `container max-w-*` and section spacing pattern.
 *
 * Props:
 *   - as:        element tag, default "section"
 *   - width:     "narrow" (max-w-3xl) | "default" (max-w-5xl) | "wide" (max-w-6xl)
 *   - padded:    boolean, default true — adds responsive vertical padding
 *   - id:        optional DOM id
 *   - className: extra classes merged onto the inner container div
 *   - outerClassName: full-width background and border classes
 *   - children
 *
 * Note: this renders the outer element (with id) and an inner
 * `container max-w-*` div. Padding lives on the inner container so custom
 * spacing replaces the defaults instead of stacking on a second element.
 */
const WIDTHS = {
  narrow: "max-w-3xl",
  default: "max-w-5xl",
  wide: "max-w-6xl",
};

export default function PageContainer({
  as: Tag = "section",
  width = "default",
  padded = true,
  id,
  className = "",
  outerClassName = "",
  children,
}) {
  const widthClass = WIDTHS[width] || WIDTHS.default;

  return (
    <Tag id={id} className={cn("scroll-mt-20", outerClassName)}>
      <div className={cn("container", widthClass, padded && "py-8 md:py-10", className)}>
        {children}
      </div>
    </Tag>
  );
}
